
  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header text">
      {{ roomName }}
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <mb-alert type="warning" *ngIf="error">
        <mb-alert-description
          >Esta información no está disponible por el momento, volvé a intentar más
          tarde.</mb-alert-description
        >
      </mb-alert>
      <div *ngIf="!error">
        <slider
          *ngIf="dialogData.room.images.length > 0"
          class="mb-col-12"
          [items]="dialogData.room.images"
          [itemsCant]="1"
        ></slider>
        <div class="mb-col-12">
          <div
            class="description-container"
            *ngIf="dialogData.room.description.length > 0"
          >
            <h3 class="title" i18n="@@modals_room_informacion_sobre_la_habitacion">
              Información sobre la habitación
            </h3>
            <p [innerHtml]="dialogData.room.description"></p>
          </div>
          <!--
          <div class="amenities-container" *ngIf="dialogData.room.amenities.length > 0">
            <amenities
              [isDisney]="dialogData.isDisney"
              [amenities]="dialogData.room.amenities"
            ></amenities>
          </div>
         -->
        </div>
      </div>
    </div>
  </mb-dialog-body>

